// extracted by mini-css-extract-plugin
module.exports = {"G_7_1":"G_G_7_1__RSWzt","G_7_2":"G_G_7_2__6uTzr"};